import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardService } from '../../services/wealthlane-award-services';

const useRsuAwardParticipantStatusOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const rsuAwardParticipantStatus = useQuery(
    ['getRsuAwardParticipantStatus'],
    async () => {
      return await handleRequest(RsuAwardService.getApiAwardApiAppRSUAwardRSUAwardStatuses());
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return rsuAwardParticipantStatus;
};

export default useRsuAwardParticipantStatusOptions;
